import React, { ComponentType } from 'react';
import {
  BaseInputProps,
  ShortText,
  LongText,
  Dropdown,
  Checkbox,
  DateInput,
  DateTime,
  Number,
} from '../../fields';
import { CustomField, CustomFieldType } from '@wix/bex-core';

type InputElements = {
  [fieldType in CustomFieldType]: ComponentType<BaseInputProps<any>>;
};

const INPUT_ELEMENTS: InputElements = {
  dropdown: Dropdown,
  checkbox: Checkbox,
  shortText: ShortText,
  longText: LongText,
  date: DateInput,
  dateTime: DateTime,
  integer: Number,
  decimal: Number,
};

export interface FormFieldInputProps {
  dataHook?: string;
  initialValue?: any;
  schema: CustomField;
  onChange: (newValue: any) => void;
  inputRef?: BaseInputProps<any>['inputRef'];
}

export const FormFieldInput = ({
  dataHook,
  schema,
  initialValue,
  onChange,
  inputRef,
}: FormFieldInputProps) => {
  if (INPUT_ELEMENTS.hasOwnProperty(schema.type)) {
    const FieldInput = INPUT_ELEMENTS[schema.type];

    return (
      <FieldInput
        dataHook={dataHook}
        initialValue={initialValue}
        schema={schema}
        onChange={(newValue) => onChange(newValue)}
        inputRef={inputRef}
      />
    );
  }

  return null;
};
